<label class="flex items-center gap-2 cursor-pointer" [class.opacity-50]="isDisabled()" [class.cursor-not-allowed]="isDisabled()">
  <input
    type="checkbox"
    class="w-4 h-4 rounded cursor-pointer"
    style="accent-color: var(--talos-ink);"
    [id]="id()"
    [checked]="checked()"
    [disabled]="isDisabled()"
    (change)="onChange($event)"
  />
  @if (label()) {
    <span class="text-sm text-talos-ink">{{ label() }}</span>
  }
</label>
